<app-header></app-header>
<div *ngIf="loadingOverlay">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple">
    <p class="loader-message">Loading...</p>
    </ngx-spinner>
</div>
<div class="landing-page">
    <router-outlet></router-outlet>
</div>
<app-footer [topArticles] = "topArticles"></app-footer>